import Text from '@skapa/Text';
import React from 'react';
import styles from './CountBadge.module.scss';

type Props = { count: number };

const CountBadge: React.FC<Props> = ({ count }) => {
    return (
        <div className={styles.wrapper}>
            <Text textStyle="Heading.XS" className={styles.countBadge}>
                {count}
            </Text>
        </div>
    );
};

export default CountBadge;
